import { Routes } from '@angular/router';
import { authGuard } from '@shared/guards/auth.guard';

export const routes: Routes = [
	{
		path: 'login',
		loadChildren: async () => import('./login/login.routes').then(m => m.loginRoutes)
	},
	{
		path: 'not-found',
		canActivate: [authGuard],
		loadComponent: async () => import('./not-found/not-found')
	},
	{
		path: '',
		canActivate: [authGuard],
		loadComponent: async () => import('./layouts/main/main-layout').then(m => m.MainLayout),
		children: [
			{ path: '', pathMatch: 'full', redirectTo: 'my-customers' },
			{
				path: 'my-customers',
				loadChildren: async () => import('./my-customers/my-customers.routes').then(m => m.myCustomersRoutes)
			},
			{
				path: 'workbook',
				loadChildren: async () => import('./workbook/workbook.routes').then(m => m.workbookRoutes)
			},
			{
				path: 'admin',
				loadChildren: async () => import('./admin/admin.routes').then(m => m.adminRoutes)
			},
			{ path: '**', redirectTo: '/not-found' }
		]
	}
];
